module.exports = __webpack_public_path__ + "static/media/thumbnail.1fcb49d5.jpg";